import ImportService from './import.service'

export default class ZoneChargesService {
  constructor({ zoneChargesApiHost, productSdk }) {
    this.zoneChargesApiHost = zoneChargesApiHost
    this.productSdk = productSdk
  }

  // L'import de zone-charges n'a pas d'équivalent dans le SDK produit (seul le GET y est exposé).
  async import(cooperativeId, file) {
    return ImportService.import(
      `${this.zoneChargesApiHost}/backoffice/v1/cooperatives/${cooperativeId}/zone-charges`,
      file,
    )
  }

  async downloadZoneCharges(cooperativeId) {
    // Troisième argument : ResponseType.CSV, qui pose l'en-tête `Accept: text/csv`.
    return this.productSdk.getDistributorZoneCharges({ cooperativeId }, undefined, 'csv')
  }
}
